"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCard = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledCard = styled_components_1.default.div `
  align-items: center;
  border-top: 1px solid ${config_1.colors.pavement};
  color: ${config_1.colors.black};
  display: flex;
  font: Bold ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  height: 45px;
  outline: none;
  padding: 0;
  text-align: center;
  width: 100%;

  &:nth-child(1) {
    border: none;
  }

  &:hover,
  &:focus {
    color: ${config_1.colors.blurple};
    cursor: pointer;
  }

  @media ${config_1.device.tablet} {
    text-align: start;
  }
`;
